import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const RoomsStyledContainer = styled.div(
  props => `
  border-radius: ${props.theme.misc.borderRadius.base};
  margin: ${props.theme.spacing.xlarge} 0 0 0;
`,
);

export const NoRoomsAvailableContainer = styled.div(
  props => `
  padding: ${props.theme.spacing.xlarge};
`,
);

export const NoRoomsAvailableText = styled.div`
  color: ${props => props.theme.colors.goBrandBlue.base} ${textSizes.MediumW3};
`;

export const RightInnerWrapper = styled.div(
  props => `
  display:flex;
  flex-direction: column;
  background-color: #fff;
  width:100%;
`,
);

export const FlexWrap = styled.div(
  props => `
      display:flex;
      `,
);

export const RightDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  width:${props.noInclusions ? '25%' : '20%'}
  `,
);
